import { useState } from 'react';

import { getAllCountries, getCountryByCode, getRegionsByCountryCode } from '../../../../general/countryRegion';
import { NibCardItem as CardItem } from '../../NibCard';
import AutoComplete from '../../NibCountrySelector/AutoComplete';
import SubInput from './SubInput';

const InputCountryRegionContainer = ({
  country = false,
  region = false,
  subInputs = [],
  required = false,
  label,
  formik,
}) => {
  const [showInfo, toggleInfo] = useState(false);

  const handleChange = (key) => (val) => {
    if (key === 'country') {
      formik.setFieldValue(country.name, val ? val.code : null);
    } else if (key === 'region') {
      formik.setFieldValue(region.name, val ? val.code : null);
    }
  };

  return (
    <div className="ui-card-item-sub">
      <CardItem btns={['info']} onInfo={() => toggleInfo(!showInfo)} name={`${label} ${required ? '*' : ''}`}>
        {country && country.name && (
          <div className="ui-card-item">
            <AutoComplete
              variant={'standard'}
              helperText={(showInfo && country.helperText) || ''}
              label={country.label || 'Choose a country'}
              options={getAllCountries()}
              onChange={handleChange('country')}
              value={getCountryByCode(formik.values[country.name])}
              required={country.required || false}
              useFlag
            />
            {formik.touched[country.name] && formik.errors[country.name] && (
              <p className={'customErrorMsg'}>{formik.errors[country.name]}</p>
            )}
          </div>
        )}

        {formik.values[country.name] && region && region.name && (
          <div className="ui-card-item">
            <AutoComplete
              variant={'standard'}
              helperText={(showInfo && region.helperText) || ''}
              label={region.label || 'Choose a Region'}
              options={getRegionsByCountryCode(formik.values[country.name])}
              onChange={handleChange('region')}
              value={
                getRegionsByCountryCode(formik.values[country.name]).filter(
                  (reg) => reg.code === formik.values[region.name],
                )[0] || null
              }
              required={region.required || false}
            />
          </div>
        )}

        {subInputs && subInputs.length
          ? subInputs.map((item) => <SubInput {...item} formik={formik} showInfo={showInfo} />)
          : ''}
      </CardItem>
    </div>
  );
};

export default InputCountryRegionContainer;
